import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";

const TopBar = ({ message }) => {
  const [showMsg, setShowMsg] = useState(false);

  useEffect(() => {
    const show = JSON.parse(window.localStorage.getItem("showMsg"));
    setShowMsg(show === true || show === false ? show : true);
  }, []);

  const handleShow = (e) => {
    e.preventDefault();
    setShowMsg(false);
    window.localStorage.setItem("showMsg", false);
  };

  if (showMsg === true) {
    return (
      <div
        className='d-flex justify-content-between align-items-center'
        style={{
          height: "25px",
          padding: "0px 8px",
          background:
            "linear-gradient(110deg, rgb(29, 75, 98) 60%, rgb(36, 95, 104) 60%)",
          overflow: "hidden",
        }}
      >
        <span
          style={{
            color: "#fff",
          }}
        >
          {message ? message : ""}
        </span>
        <Button variant='danger' onClick={handleShow}>
          x
        </Button>
      </div>
    );
  } else {
    return "";
  }
};

export default TopBar;
